import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import ResultTable from '../ResultTable';
import ResultDetail from '../ResultDetail';

export default class ResultPanel extends Component {
    render() {
        return (
            <div>
                <Route exact path={this.props.match.path + "/"} component={ResultTable} />
                <Route path={this.props.match.path + "/detail"} component={ResultDetail} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Healthcheck/ResultPanel/index.js